/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Downloading_FileInputs */

const en_downloading_file = /** @type {(inputs: Downloading_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Downloading file...`)
};

const nl_downloading_file = /** @type {(inputs: Downloading_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestand aan het downloaden...`)
};

/**
* | output |
* | --- |
* | "Downloading file..." |
*
* @param {Downloading_FileInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const downloading_file = /** @type {((inputs?: Downloading_FileInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloading_FileInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_downloading_file(inputs)
	return en_downloading_file(inputs)
});